module.exports = __webpack_public_path__ + "static/Aaron-c9717cd5db35975fbab775e14e12ed00.png";